;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import axiosInstance from '../utils/axios';
import { logSentryError } from '../utils/logSentry';

export type ApiLocation = {
  lat: string;
  lng: string;
  postalCode: string;
  city: string;
};

export const getLocationsForAutocomplete = async (search: string = '') => {
  try {
    const { data } = await axiosInstance.get<ApiLocation[]>(`/autocomplete/locations`, { params: { search } });

    return data;
  } catch (error) {
    logSentryError(error);
  }
  return [];
};
